<template>
  <v-container fluid class="white page__container--padding py-5">
    <div class="d-flex align-center gap-2">
      <back-btn :to="{ name: 'SellerResults' }" />
      <div class="outlined-card p-1">
        <icon-title
          :text="isInvocidedView ? 'RENGLONAJE' : 'RENGLONES SIN FACTURAR'"
          icon="mdi-clock-outline"
        />
      </div>
    </div>

    <menu-divisiones
      :loader="loading"
      :view="!isInvocidedView ? 'not-invoiced' : 'invoiced'"
      :active-d-i-v-i="activeDivision"
      :divisiones="divisions"
      @filterDIVIs="(division) => (activeDivision = division)"
    />

    <v-row class="my-4">
      <v-col sm="12" md="4" xl="2">
        <div class="d-flex align-items-center">
          <label class="mr-2">Familia:</label>
          <v-select
            v-model="selectedFamily"
            :items="families"
            item-text="BEZEI"
            hide-details
            small
            dense
            solo
          />
        </div>
      </v-col>
      <v-col sm="12" md="4" xl="3">
        <div class="d-flex align-items-center">
          <label class="mr-2">Buscar código:</label>
          <search-input
            v-model="search"
            class="search-input-width"
            :hide-details="true"
          />
        </div>
      </v-col>
    </v-row>

    <v-data-table
      :headers="filteredHeaders"
      :items="filteredItems"
      :search="search"
      class="elevation-2 table__desing-general table__movements--scroll"
      :mobile-breakpoint="null"
      :loading="loading"
      loading-text="Cargando... Por favor espere"
      :footer-props="footerProps"
      :options="dataTableOptions"
    >
      <template #header>
        <thead v-if="isInvocidedView" style="border-bottom: 0">
          <tr>
            <th colspan="7"></th>
            <th colspan="2" class="text-center">
              <b>Comprados en el periodo</b>
            </th>
            <th></th>
          </tr>
        </thead>
      </template>

      <template #[`item.id`]="{ item }">
        {{ items.indexOf(item) + 1 }}
      </template>

      <template #[`item.TMONT`]="{ item }">
        ${{ item.TMONT | formatCurrency }}
      </template>

      <template #[`item.PORCE`]="{ item }">
        {{ item.PORCE | formatCurrency }}%
      </template>

      <template #[`item.MATNR`]="{ item }">
        {{ parseInt(item.MATNR) }}
      </template>

      <template #[`item.TCANT`]="{ item }">
        {{ item.TCANT | formatCurrency }}
      </template>

      <template v-if="isInvocidedView" #foot>
        <tfoot>
          <tr>
            <td style="text-align: right" :colspan="8"><b>TOTAL $ / %</b></td>
            <td style="text-align: center">
              <b>${{ totalAmount | formatCurrency }}</b>
            </td>
            <td style="text-align: center">
              <b>{{ totalPorentage | formatCurrency }}%</b>
            </td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import IconTitle from '@/components/IconTitle.vue';
  import BackBtn from '@/components/BackBtn.vue';
  import MenuDivisiones from './components/MenuDivisiones';
  import SearchInput from '@/components/SearchInput.vue';
  import axios from '@/plugins/axios';
  import { mapGetters } from 'vuex';
  import userAuthOrStorage from '@/mixins/userAuthOrStorage';
  import { Roles } from '@/core/constants/roleConstants';
  export default {
    components: {
      IconTitle,
      BackBtn,
      MenuDivisiones,
      SearchInput,
    },
    mixins: [userAuthOrStorage],
    data() {
      return {
        loading: true,
        activeDivision: 'todos',
        selectedFamily: 'Todos',
        search: '',
        items: [],
        dataTableOptions: {
          itemsPerPage: 15,
        },
        footerProps: {
          itemsPerPageOptions: [5, 10, 15, { text: 'Todos', value: -1 }],
          itemsPerPageText: 'Mostrar en grupo de:',
          showCurrentPage: false,
          pageText: '{0} al {1} de {2}',
        },
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      divisions() {
        return [...new Set(this.items.map((item) => item.DIVISION))];
      },
      families() {
        return ['Todos', ...new Set(this.items.map((item) => item.BEZEI))];
      },
      filteredItems() {
        let filtered =
          this.activeDivision == 'todos'
            ? this.items
            : this.items.filter((item) => item.DIVISION == this.activeDivision);

        if (this.selectedFamily !== 'Todos') {
          filtered = filtered.filter(
            (item) => item.BEZEI === this.selectedFamily
          );
        }

        return filtered;
      },
      filteredHeaders() {
        const commonHeaders = [
          { text: 'N°', value: 'id', align: 'center' },
          { text: 'División', value: 'DIVISION', align: 'center' },
          { text: 'Subdivisión', value: 'SUBDIVISION', align: 'center' },
          { text: 'Clave', value: 'MVGR4', align: 'center' },
          { text: 'Familia', value: 'BEZEI', align: 'center' },
          { text: 'Código', value: 'MATNR', align: 'center' },
          { text: 'Descripción', value: 'MAKTX', align: 'center' },
        ];

        if (this.isInvocidedView) {
          commonHeaders.push(
            { text: 'Piezas', value: 'TCANT', align: 'center' },
            { text: 'Monto', value: 'TMONT', align: 'center' },
            { text: 'Porcentaje total', value: 'PORCE', align: 'center' }
          );
        }

        return commonHeaders;
      },
      isInvocidedView() {
        return this.$route.params.status === 'facturados';
      },
      totalAmount() {
        return this.items.reduce(
          (sum, item) => sum + parseFloat(item.TMONT || 0),
          0
        );
      },
      totalPorentage() {
        return this.items.reduce(
          (sum, item) => sum + parseFloat(item.PORCE || 0),
          0
        );
      },
    },
    mounted() {
      const validStatus = ['sin-facturar', 'facturados'];
      const currentStatus = this.$route.params.status;

      if (!validStatus.includes(currentStatus)) {
        return this.$router.replace({ name: '403' });
      }

      this.fetchLineItems();
    },
    methods: {
      async fetchLineItems() {
        const role = this.$route.meta.role;
        const mapRoles = {
          Seller: { code: this.validateSellerCode(), path: Roles.SELLER },
          Manager: { code: this.validateManagerCode(), path: Roles.MANAGER },
          Regional: {
            code: this.validateRegionalManagerCode(),
            path: Roles.REGIONAL_MANAGER,
          },
          Director: { code: null, path: Roles.DIRECTOR },
        };

        try {
          const { data } = await axios.get(
            '/renglonaje/invoiced-and-not-invoiced/' + mapRoles[role].path,
            {
              params: {
                PERNR: mapRoles[role].code,
                VTWEG: this.user.VTWEG,
                opt: this.isInvocidedView ? 1 : 2,
              },
            }
          );
          this.items = data.data;
        } catch {
          this.$toast.error('Ocurrió un error al obtener los renglones');
        }
        this.loading = false;
      },
    },
  };
</script>

<style></style>
